var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9091 0H7.72727C6.90751 0 6.12133 0.327777 5.54167 0.911223C4.96201 1.49467 4.63636 2.28599 4.63636 3.11111V12.4444H10.8182V9.33333L17 14L10.8182 18.6667V15.5556H4.63636V24.8889C4.63636 25.714 4.96201 26.5053 5.54167 27.0888C6.12133 27.6722 6.90751 28 7.72727 28H30.9091C31.7289 28 32.515 27.6722 33.0947 27.0888C33.6744 26.5053 34 25.714 34 24.8889V3.11111C34 2.28599 33.6744 1.49467 33.0947 0.911223C32.515 0.327777 31.7289 0 30.9091 0ZM26.2727 21.7778H20.0909V18.6667H26.2727V21.7778ZM30.9091 15.5556H20.0909V12.4444H30.9091V15.5556ZM30.9091 9.33333H20.0909V6.22222H30.9091V9.33333ZM4.63636 15.5556H0V12.4444H4.63636V15.5556Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.362a5af07beabca1efc5aa90c3648a62.svg";
export { ForwardRef as ReactComponent };